import { fromJS } from 'immutable';

import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_PERSONAL_ACCIDENT_STATE,
  RESET_PERSONAL_ACCIDENT_INJURY_STATE,
  RESET_PERSONAL_ACCIDENT_INJURY_LEAVE_PERMANENTLY_STATE,
  RESET_PERSONAL_ACCIDENT_INJURY_RESULT_STATE,
} from './constants';

// The initial state of the App
const initialState = fromJS({
  form: {
    isThisClaimRelatedToPersonalAccident: '',
    infoClaimRelatedToPersonalAccidentItems: [],
    isThisClaimRelatedToLossOfLifeCausedByAnInjury: '',
    infoClaimRelatedToLossOfLifeItems: [],
    didTheInjuryLeaveYouPermanentlyDisabled: '',
    infoDidTheInjuryLeaveYouPermanentlyDisabledItems: [],
    didTheInjuryResultInYourInabilityToReturnToWork: '',
    dateYouWereOriginallyDueBackAtWork: '',
    infoYourInabilityToReturnToWorkItems: [],
  },
  errors: [],
});

const initialPersonalAccident = {
  form: {
    infoClaimRelatedToPersonalAccidentItems: [],
    isThisClaimRelatedToLossOfLifeCausedByAnInjury: '',
    infoClaimRelatedToLossOfLifeItems: [],
    didTheInjuryLeaveYouPermanentlyDisabled: '',
    infoDidTheInjuryLeaveYouPermanentlyDisabledItems: [],
    didTheInjuryResultInYourInabilityToReturnToWork: '',
    dateYouWereOriginallyDueBackAtWork: '',
    infoYourInabilityToReturnToWorkItems: [],
  },
};

const initialClaimRelatedToLossOfLife = {
  form: {
    infoClaimRelatedToLossOfLifeItems: [],
    didTheInjuryLeaveYouPermanentlyDisabled: '',
    infoDidTheInjuryLeaveYouPermanentlyDisabledItems: [],
    didTheInjuryResultInYourInabilityToReturnToWork: '',
    dateYouWereOriginallyDueBackAtWork: '',
    infoYourInabilityToReturnToWorkItems: [],
  },
};

const initialClaimRelatedInjuryLeaveYouPermanently = {
  form: {
    infoDidTheInjuryLeaveYouPermanentlyDisabledItems: [],
    didTheInjuryResultInYourInabilityToReturnToWork: '',
    dateYouWereOriginallyDueBackAtWork: '',
    infoYourInabilityToReturnToWorkItems: [],
  },
};

const initialClaimRelatedInjuryResult = {
  form: {
    dateYouWereOriginallyDueBackAtWork: '',
    infoYourInabilityToReturnToWorkItems: [],
  },
};

function personalAccidentSCTIStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);
    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;
    case NEXT:
      return state.merge({ errors: action.errors });
    case RESET:
      return initialState;
    case RESET_PERSONAL_ACCIDENT_STATE:
      return state
        .setIn(['form', 'infoClaimRelatedToPersonalAccidentItems'], [])
        .setIn(['form', 'infoClaimRelatedToLossOfLifeItems'], [])
        .setIn(['form', 'infoDidTheInjuryLeaveYouPermanentlyDisabledItems'], [])
        .setIn(['form', 'infoYourInabilityToReturnToWorkItems'], [])
        .mergeDeep(initialPersonalAccident);
    case RESET_PERSONAL_ACCIDENT_INJURY_STATE:
      return state
        .setIn(['form', 'infoClaimRelatedToLossOfLifeItems'], [])
        .setIn(['form', 'infoDidTheInjuryLeaveYouPermanentlyDisabledItems'], [])
        .setIn(['form', 'infoYourInabilityToReturnToWorkItems'], [])
        .mergeDeep(initialClaimRelatedToLossOfLife);
    case RESET_PERSONAL_ACCIDENT_INJURY_LEAVE_PERMANENTLY_STATE:
      return state
        .setIn(['form', 'infoDidTheInjuryLeaveYouPermanentlyDisabledItems'], [])
        .setIn(['form', 'infoYourInabilityToReturnToWorkItems'], [])
        .mergeDeep(initialClaimRelatedInjuryLeaveYouPermanently);
    case RESET_PERSONAL_ACCIDENT_INJURY_RESULT_STATE:
      return state
        .setIn(['form', 'infoYourInabilityToReturnToWorkItems'], [])
        .mergeDeep(initialClaimRelatedInjuryResult);
    default:
      return state;
  }
}

export default personalAccidentSCTIStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.PersonalAccident/reducer.js